import { XGridTable, XGridTableProps } from './XGridTable';
import { Grid } from '@mui/material';
import { GridCellParams, GridColDef, GridPreProcessEditCellProps, GridRowId, GridRowsProp, GridValidRowModel } from '@mui/x-data-grid-pro';

/* 
*   Компонент - обертка для таблицы DataGridPro (XGrid). 
*/

type MuiTableProps = Omit<XGridTableProps, 'columns' | 'rows'>;

export type GridCellEditCommitParams = {
    id: GridRowId,
    value: any,
    field: string,
}

type TableProps = MuiTableProps & {
    onSelectionModelChange?: XGridTableProps['onRowSelectionModelChange'],
    selectionModel?: XGridTableProps['rowSelectionModel'],
    onCellEditCommit?: (params: GridCellEditCommitParams, editCellParams: GridPreProcessEditCellProps) => void,
}

export type TableColumns = GridColDef & {
    hide?: boolean,
}

export type IXGridTableWrap<R extends GridValidRowModel> = {
    columns: TableColumns[],
    rows: GridRowsProp<R>,
    dataIsLoading: boolean,                  // состояние загрузки данных: если true - показывает лоадер загрузки данных.   
    tableHeight?: string | number,           // высота таблицы.
    tableWidth?: string | number,            // ширина таблицы.  
    tableProps?: TableProps,  // параметры таблицы DataGridPro (XGrid).
}

const transformTableProps = (columns: TableColumns[], tableProps?: TableProps): {
    0: TableColumns[],
    1: MuiTableProps,
} & Array<any> => {

    const hiddenColumns: { [key: string]: boolean } = {};
    columns.forEach((column: TableColumns) => {
        if (column?.hide) {
            hiddenColumns[column.field] = false
        }
    })

    const resultColumns = columns.map((col) => ({
        ...col,
        // Нужно только для того, чтобы скрыть тултип, по умолчанию  MUI добавляет аттрибут title  ко всем ячейкам
        renderCell: col.renderCell
            ? col.renderCell
            : col.getActions
                ? undefined
                : (({ value, row, colDef, api }: GridCellParams) => <>{col.valueFormatter ? col.valueFormatter(value, row, colDef, api) : value}</>),
        preProcessEditCellProps: (col.editable && tableProps && tableProps.onCellEditCommit)
            ? (params: GridPreProcessEditCellProps) => {
                tableProps.onCellEditCommit && tableProps.onCellEditCommit({
                    id: params.id,
                    field: col.field,
                    value: params.props.value,
                }, params);
                return params.props;
            }
            : undefined,
    }));

    if (!tableProps && hiddenColumns) {
        return [
            resultColumns,
            {
                initialState: {
                    columns: {
                        columnVisibilityModel: hiddenColumns,
                    },
                },
            },
        ]
    }

    const resultProps = {
        ...tableProps,
        onRowSelectionModelChange: tableProps?.onRowSelectionModelChange ?? tableProps?.onSelectionModelChange,
        rowSelectionModel: tableProps?.rowSelectionModel ?? tableProps?.selectionModel,
        initialState: {
            ...tableProps?.initialState,
            columns: {
                columnVisibilityModel: { ...tableProps?.initialState?.columns?.columnVisibilityModel, ...hiddenColumns },
            },
        },

    };

    return [resultColumns, resultProps];
}

export const XGridTableWrap = <R extends GridValidRowModel,>({
    columns,
    rows,
    dataIsLoading,
    tableProps,
    tableHeight = 'calc(100vh - 170px)',
    tableWidth = '100%',
}: IXGridTableWrap<R>) => {

    const [transformedColumns, transformedTableProps] = transformTableProps(columns, tableProps);

    return (
        <Grid sx={{ height: tableHeight, width: tableWidth }}>
            <XGridTable
                columns={transformedColumns}
                rows={rows || []}
                loading={dataIsLoading}
                {...transformedTableProps}
            />
        </Grid>
    );
}